import Vue from 'vue'
import Router from 'vue-router'
import Help from '@/components/help.vue' 
import appeal from '@/components/appeal/appeal.vue' 
import changeActiveState from '@/components/changeActiveState/changeActiveState.vue' 
import SecurityInformation from '@/components/changeActiveState/SecurityInformation.vue'
import Home from '@/components/home.vue' 

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/home-page/',
  routes: [
    {
      path: '/',
      name:"",
      component: Home
    },
    { 
      path: '/Help', 
      name:"Help",
      component: Help 
    },
    { 
      path: '/appeal', 
      name:"appeal",
      component: appeal 
    },
    { 
      path: '/changeActiveState', 
      name:"changeActiveState",
      component: changeActiveState 
    },
    {
      path: '/fillInAppealInfo',
      name: "fillInAppealInfo",
      component : SecurityInformation
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js